import gql from 'graphql-tag';

export const CREW_FRAGMENT = gql`
  fragment CrewFragment on Crew {
    id
    name
    color
    description
  }
`;
